:root ._dsp-flex{display:flex;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._items-center{align-items:center;}
:root ._grow-1{flex-grow:1;}
:root ._mt-t-space-lar3294{margin-top:var(--t-space-large);}
:root ._mr-t-space-lar3294{margin-right:var(--t-space-large);}
:root ._mb-t-space-lar3294{margin-bottom:var(--t-space-large);}
:root ._ml-t-space-lar3294{margin-left:var(--t-space-large);}
:root ._items-stretch{align-items:stretch;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._fd-row{flex-direction:row;}